<script lang="ts">
export default {
  name: 'HistoryNavigator',
};
</script>

<script setup lang="ts">
import undo_img from '@/assets/images/undo_arrow.svg';
import redo_img from '@/assets/images/redo_arrow.svg';
import { computed, inject } from 'vue';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { REDO_TOWER, UNDO_TOWER } from '@/store/CustomEvents';

const store = inject<Store<AppState>>('store');

const isRedoPossible = computed<boolean>(() => {
  if (store?.state.towerCanvasState.currentTowerHistoryIndex === undefined) {
    return false;
  }

  return (
    store?.state.towerCanvasState.towerHistoryStack.length !==
    store?.state.towerCanvasState.currentTowerHistoryIndex + 1
  );
});

const isUndoPossible = computed<boolean>(() => {
  if (
    store?.state.towerCanvasState.currentTowerHistoryIndex === undefined ||
    store.state.towerCanvasState.towerHistoryStack.length === 0 ||
    store.state.towerCanvasState.currentTowerHistoryIndex === 0
  ) {
    return false;
  }

  return true;
});

function undoTowerHistory(): void {
  dispatchEvent(
    new CustomEvent(UNDO_TOWER)
  )
}

function redoTowerHistory(): void {
  dispatchEvent(
    new CustomEvent(REDO_TOWER)
  )
}
</script>

<template>
  <div class="flex items-end py-2 gap-1 pointer-events-auto">
    <button
      class="flex items-center justify-center text-2xl w-10 h-10
          ease-in shadow-lg rounded-l-lg"
      :class="{ 'opacity-50 cursor-not-allowed' : !isUndoPossible }"
      @click="undoTowerHistory"
    >
      <img :src="undo_img" class="h-6 self-center" />
    </button>

    <button
      class="flex items-center justify-center text-2xl w-10 h-10
          ease-in shadow-lg rounded-r-lg"
      :class="{ 'opacity-50 cursor-not-allowed' : !isRedoPossible }"
      @click="redoTowerHistory"
    >
      <img :src="redo_img" class="h-6 self-center" />
    </button>
  </div>
</template>

<style scoped>
button {
  border: 1px solid var(--tower-v2-border-color);
  background-color: var(--tower-v2-alt-bg-color);
}
button:hover {
  background-color: var(--tower-v2-hover-color);
}
</style>